import React, { VFC } from "react";
import { makeStyles } from "@material-ui/core";

import Container from "@eGroupTeam/material/Container";
import Typography from "@eGroupTeam/material/Typography";
import Grid from "@eGroupTeam/material/Grid";
import { Box } from "@eGroupTeam/material";
import Aos from "@eGroupTeam/material-module/Aos";
import pricingSvg from "./images/pricing-image.svg";
import Bounce from "../components/Bounce";
import Header from "../components/Header";
import ContactUsSection from "../components/ContactUsSection";

import ServicePlanSection from "./ServicePlanSection";
import MPPriceItem from "./MPPriceItem";

const useStyles = makeStyles((theme) => ({
  middleSection: {
    marginTop: "4rem",
  },
  textContents: {
    marginTop: "5rem",
    [theme.breakpoints.down("sm")]: {
      marginTop: "0",
    },
    "& h2": {
      fontSize: "31px",
      marginBottom: "0.5rem",
      lineHeight: "1.2",
      color: theme.egPalette.primary[1],
    },
    "& h6": {
      fontSize: "18px",
      color: "#444",
      lineHeight: "1.2",
      marginBottom: "0.5rem",
    },
    "& h3": {
      fontSize: "20px",
      color: theme.egPalette.info[2],
      lineHeight: "1.2",
      marginBottom: "0.5rem",
      margin: "15px 0",
    },
  },
}));

const Pricing: VFC = () => {
  const classes = useStyles();
  return (
    <>
      <Header>
        <Typography
          variant="h2"
          fontWeight={700}
          color="inherit"
          align="center"
        >
          服務價格
        </Typography>
      </Header>
      <Box>
        <Container className={classes.middleSection}>
          <Box py={2}>
            <Grid container spacing={3}>
              <Grid item sm={12} md={6}>
                <Aos variant="slideInLeft" config={{ duration: 500 }}>
                  <Bounce>
                    <Box textAlign="center">
                      <img src={pricingSvg} alt="Reference" width="80%" />
                    </Box>
                  </Bounce>
                </Aos>
              </Grid>
              <Grid item sm={12} md={6}>
                <Aos variant="slideInRight" config={{ duration: 500 }}>
                  <Box className={classes.textContents}>
                    <Typography variant="h2" fontWeight={700}>
                      購買MICEPoint，開始你的活動
                    </Typography>
                    <Typography variant="h6" fontWeight={700}>
                      MICEPoint 點數是 MICEPass 平台的支付方式
                    </Typography>
                    <ul>
                      <li>
                        <Typography
                          variant="body1"
                          paragraph
                          color="textSecondary"
                        >
                          MICEPoint 簡稱 MP.
                        </Typography>
                      </li>
                      <li>
                        <Typography
                          variant="body1"
                          paragraph
                          color="textSecondary"
                        >
                          首次登入，贈送 MP 3000.
                        </Typography>
                      </li>
                    </ul>
                    <Typography variant="h3" fontWeight={700}>
                      MICEPoint 價格
                    </Typography>
                    <Grid container>
                      <Grid item xs={12} sm={4}>
                        <MPPriceItem mp="3,000" twd="2,850" />
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <MPPriceItem mp="5,000" twd="4,550" />
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <MPPriceItem mp="10,000" twd="8,000" />
                      </Grid>
                    </Grid>
                  </Box>
                </Aos>
              </Grid>
            </Grid>
          </Box>
        </Container>
        <ServicePlanSection />
        <ContactUsSection />
      </Box>
    </>
  );
};

export default Pricing;
